import { Meta, Field, CompositeField } from '../types';

export const collectRelatedFields = (
  meta: Meta,
  itemName: string
): Set<string> => {
  const relatedFields = new Set<string>();

  const getFieldNameFromPath = (path: string): string => {
    return path.split("/").pop()!;
  };

  const findCompositeField = (fields: Field[]): CompositeField | null => {
    for (const field of fields) {
      if (typeof field === "object" && field.name === itemName) {
        return field;
      }
    }
    return null;
  };

  meta.setters.layout.forEach((section) => {
    section.items.forEach((item) => {
      const targetField = findCompositeField(item.fields);
      
      if (targetField) {
        targetField.fields.forEach((f) => {
          if (typeof f === "string") {
            const fieldName = getFieldNameFromPath(f);
            relatedFields.add(fieldName);
          }
        });
      }
    });
  });

  const dependentFields = new Set<string>();
  meta.setters.props.forEach((prop) => {
    if (prop.effects?.dependencies) {
      const hasDependency = prop.effects.dependencies.some((dep) =>
        relatedFields.has(dep)
      );
      if (hasDependency) {
        dependentFields.add(prop.name);
      }
    }
  });

  return new Set([...relatedFields, ...dependentFields]);
};